var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitnessicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2017_9944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7C1.27539 3.13401 4.4094 0 8.27539 0H42.2754C46.1414 0 49.2754 3.13401 49.2754 7V41C49.2754 44.866 46.1414 48 42.2754 48H8.27539C4.4094 48 1.27539 44.866 1.27539 41V7Z",
    fill: "#E1DAF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2508 21.0251L28.2008 14.9751L28.6258 14.5501C29.0091 14.1667 29.4841 13.9792 30.0508 13.9876C30.6174 13.9959 31.0924 14.1917 31.4758 14.5751L34.7008 17.8001C35.0841 18.1834 35.2758 18.6542 35.2758 19.2126C35.2758 19.7709 35.0841 20.2417 34.7008 20.6251L34.2508 21.0251ZM21.9258 33.4001C21.5424 33.7834 21.0716 33.9751 20.5133 33.9751C19.9549 33.9751 19.4841 33.7834 19.1008 33.4001L15.8758 30.1751C15.4924 29.7917 15.3008 29.3209 15.3008 28.7626C15.3008 28.2042 15.4924 27.7334 15.8758 27.3501L16.2758 26.9501L22.3258 33.0001L21.9258 33.4001ZM25.5508 32.7001C25.3508 32.9001 25.1174 33.0001 24.8508 33.0001C24.5841 33.0001 24.3508 32.9001 24.1508 32.7001L16.5758 25.1251C16.3758 24.9251 16.2758 24.6917 16.2758 24.4251C16.2758 24.1584 16.3758 23.9251 16.5758 23.7251L18.0008 22.2751C18.2008 22.0751 18.4383 21.9751 18.7133 21.9751C18.9883 21.9751 19.2258 22.0751 19.4258 22.2751L21.0008 23.8501L25.1508 19.7001L23.5758 18.1251C23.3758 17.9251 23.2758 17.6917 23.2758 17.4251C23.2758 17.1584 23.3758 16.9251 23.5758 16.7251L25.0008 15.2751C25.2008 15.0751 25.4383 14.9751 25.7133 14.9751C25.9883 14.9751 26.2258 15.0751 26.4258 15.2751L34.0008 22.8501C34.2008 23.0501 34.3008 23.2876 34.3008 23.5626C34.3008 23.8376 34.2008 24.0751 34.0008 24.2751L32.5508 25.7001C32.3508 25.9001 32.1174 26.0001 31.8508 26.0001C31.5841 26.0001 31.3508 25.9001 31.1508 25.7001L29.5758 24.1251L25.4258 28.2751L27.0008 29.8501C27.2008 30.0501 27.3008 30.2876 27.3008 30.5626C27.3008 30.8376 27.2008 31.0751 27.0008 31.2751L25.5508 32.7001Z",
    fill: "#6745B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2017_9944",
    x: 0.275391,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2017_9944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2017_9944",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessicon);
export default __webpack_public_path__ + "static/media/fitness+icon.40931ccaf256c060c88792a843ef2e60.svg";
export { ForwardRef as ReactComponent };